import { CognitoAuth } from 'amazon-cognito-auth-js';
import { LOGOUT_PAGE, HOME_PAGE } from '../constants/routesConstant';
import { getStageSpecificCognitoAuthSettings, getEnvironmentStage } from '../util/envUtils';
import {
  getUserPermission,
  setAuthorizationFailure,
  setUserInfoTokensFromSession,
} from '../actions/userInfoActions';

export const cognitoAuthHandler = (stage, userInfo, dispatch) => {
  const storeInSession = authData => {
    const storage = window['sessionStorage'];
    storage.setItem('idToken', authData.idToken?.jwtToken);
  };

  const onSuccessHandler = async congnitoAuthData => {
    await dispatch(setUserInfoTokensFromSession(congnitoAuthData));
    storeInSession(congnitoAuthData);
    const { email } = congnitoAuthData?.getIdToken()?.decodePayload();

    // get the alias from email
    const user = email?.split('@')[0];
    await dispatch(getUserPermission({ userName: user }));

    if (window.location.href?.includes('access_token')) {
      // redirect the user to the home page once the token is stored
      window.location.replace(
        getStageSpecificCognitoAuthSettings(getEnvironmentStage())?.RedirectUriSignIn,
      );
    }
  };

  const onFailureHandler = () => {
    dispatch(setAuthorizationFailure(true));
  };

  const authData = getStageSpecificCognitoAuthSettings(stage);
  const cognitoAuthorizer = new CognitoAuth(authData);
  cognitoAuthorizer.userhandler = {
    onSuccess: onSuccessHandler,
    onFailure: onFailureHandler,
  };

  cognitoAuthorizer.parseCognitoWebResponse(window.location.href);
  if (window.location.pathname.toLowerCase() !== LOGOUT_PAGE && !userInfo?.isAuthorizationFailure) {
    setTimeout(() => {
      if (
        !cognitoAuthorizer.isUserSignedIn() ||
        (userInfo?.isLoggedOut === '' && userInfo?.user === '')
      ) {
        cognitoAuthorizer?.getSession();
      }
    }, 500);
  } else if (userInfo?.isLoggedOut === true) {
    cognitoAuthorizer.signOut();
    const storage = window['sessionStorage'];
    storage?.clear();
  }
};
